import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const path = `${location.pathname}${location.search}${location.hash}`;
    if (typeof window.__gaTrackPageView === "function") {
      window.__gaTrackPageView(path);
    }
  }, [location.hash, location.pathname, location.search]);
}
